const memory = {
  title: 'Memória',
  selectOrganization: 'Selecione uma organização para ver a memória dela.',
  add: 'Memória',
  search: 'Buscar memórias',
  filterStatus: 'Estado',
  filterKind: 'Tipo',
  filters: 'Filtros',
  clear: 'Limpar',
  noResults: 'Nenhuma memória com esses filtros.',
  empty: 'Nada lembrado aqui ainda.',
  loadError: 'Não foi possível carregar as memórias.',
  status: {
    active: 'Ativas',
    pending: 'Indexando',
    failed: 'Não indexada',
    expired: 'Vencidas',
  },
  statusHint: {
    pending: 'Entrando no grafo — os agentes já conseguem listá-la.',
    failed: 'Ainda não entrou no grafo; uma nova tentativa será feita.',
  },
  kinds: {
    fact: 'Fato',
    decision: 'Decisão',
    preference: 'Preferência',
    event: 'Evento',
  },
  sources: {
    ui: 'Tela',
    conversation: 'Conversa',
    workflow: 'Fluxo',
  },
  validity: {
    permanent: 'Permanente',
    until: 'Até {{date}}',
    expiringSoon: 'Vence {{date}}',
    expired: 'Venceu em {{date}}',
  },
  by: 'por {{name}}',
  via: 'via {{client}}',
  actions: {
    edit: 'Editar',
    renew: 'Renovar',
    forget: 'Esquecer',
    facts: 'Fatos',
  },
  form: {
    createTitle: 'Nova memória',
    editTitle: 'Editar memória',
    renewTitle: 'Renovar memória',
    content: 'O que lembrar',
    contentPlaceholder: 'Uma frase curta, por exemplo "A Maria Souza é a responsável pelo time de dados desde outubro de 2026."',
    kind: 'Tipo',
    scope: 'Quem vê',
    scopeOptions: {
      user: 'Só eu',
      workspace: 'Este workspace',
      organization: 'A organização',
    },
    scopeHint: 'Mudar muda quem lê. Ela sai desta lista.',
    validity: 'Validade',
    validityOptions: {
      permanent: 'Permanente',
      '1d': '1 dia',
      '7d': '7 dias',
      '30d': '30 dias',
      custom: 'Até uma data',
    },
    validityHint: 'Informação temporária (férias, sprint atual, uma indisponibilidade) deve ter validade: depois dela, os agentes deixam de usá-la.',
    date: 'Válida até',
    invalidDate: 'Escolha uma data futura.',
    save: 'Salvar',
    cancel: 'Cancelar',
    created: 'Lembrado.',
    updated: 'Memória atualizada.',
    saveError: 'Não foi possível salvar a memória.',
  },
  forget: {
    title: 'Esquecer esta memória?',
    description: 'Ela some para todos os agentes e pessoas na hora. O histórico guarda quem esqueceu e quando, mas não o conteúdo.',
    confirm: 'Esquecer',
    forgetting: 'Esquecendo…',
    cancel: 'Cancelar',
    done: 'Esquecida.',
    error: 'Não foi possível esquecer a memória.',
  },
  facts: {
    title: 'Fatos no grafo',
    description: 'O que os agentes extraíram desta memória. Um fato substituído fica no histórico, marcado como não atual.',
    empty: 'Nenhum fato ainda — a memória pode estar sendo indexada.',
    current: 'Atual',
    replaced: 'Substituído',
    since: 'desde {{date}}',
    error: 'Não foi possível carregar os fatos.',
  },
} as const;

export default memory;
